import React from 'react'
import { Virtuoso } from 'react-virtuoso'

import Statement from './Statement'
import AddNewStatementForm from './AddNewStatementForm'

const StatementList = ({
    virtuosoRef,
    activeMatchUid,
    statements,
    isAddButtonVisible,
    handleAddButtonClick,
    isTextareaVisible,
    handleSave,
    handleTextareaClose,
    selectedStatements,
    setIsTextareaVisible,
    setIsAddButtonVisible,
    handleStatementSelect,
    getStatementContextLabel,
    isAuthoringDisabled,
}) => {
    // hide the add form as a last statement in aggregate views by omitting the Virtuoso footer
    const virtuosoComponents = isAuthoringDisabled
        ? {}
        : { Footer: AddNewStatementForm }

    return (
        <div
            id="react-statements"
            style={{
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
                overflowY: 'scroll',
                flex: 1,
                padding: '8px 0px 0px 8px',
            }}
        >
            <Virtuoso
                ref={virtuosoRef}
                // Estimate for unmeasured rows so the first scrollToIndex lands close.
                defaultItemHeight={70}
                context={{
                    handleAddButtonClick,
                    isAddButtonVisible,
                    isTextareaVisible,
                    handleSave,
                    handleTextareaClose,
                    setIsTextareaVisible,
                    setIsAddButtonVisible,
                }}
                components={virtuosoComponents}
                data={statements}
                computeItemKey={(_, statement) => statement.uid}
                itemContent={(index, statement) => (
                    <div>
                        <Statement
                            contextLabel={getStatementContextLabel(statement)}
                            initialText={statement.text}
                            highlightedWords={statement.wordsToHighlight}
                            uid={statement.uid}
                            grayedOut={statement.grayedOut}
                            tags={statement.tags}
                            isSelected={selectedStatements.has(statement.uid)}
                            isActiveMatch={statement.uid === activeMatchUid}
                            onSelect={handleStatementSelect}
                            isAuthoringDisabled={isAuthoringDisabled}
                        />
                    </div>
                )}
            />
        </div>
    )
}

export default StatementList
